import { IApplicationState } from '../../types/redux';

export const selectCanLoadMore = (state: IApplicationState) => state.folders.canLoadMore;
